$(document).ready(function () {
    $(".link-download-guide").hide()
    $('#table-books').DataTable({
        proccesing: true,
        serverSide: true,
        responsive: true,
        ajax: '/admin/get-admin-books',
        columns: [{data: 'title', name: 'title'}, {data: 'country_text', name: 'country_text'}, {
            data: 'authorsName',
            name: 'authorsName'
        },],
        "columnDefs": [{
            "targets": 3, "data": "download_link", "render": function (data, type, row, meta) {
                let status = get_global_status(row.status);
                let button_reading_guide = getIconReadingGuide(row)
                return '<a href="#" data-toggle="tooltip" data-placement="top" title="' + status.title + '" ' + 'class="btn btn-' + status.color_clas + ' change-book-status btn-sm"  ' + 'data-book_id ="' + row.id + '"><span class="' + status.icon + '"></span></a> ' +
                    '<button data-toggle="tooltip" data-placement="top" title="Editar" class="btn button_almadia ' + 'edit-admin-book btn-sm"' + 'data-data ="' + row + '"><i class="far fa-edit"></i></button> ' +
                    '<button data-toggle="tooltip" data-placement="top" title="Agregar citas a libros." class="btn button_almadia ' + 'add-qoutes-book btn-sm"' + 'data-slug ="' + row.slug + '"><i class="fa-regular fa-rectangle-list"></i></button> ' +
                    '<button data-toggle="tooltip" data-placement="top" title="Agregar reseñas a libros." class="btn button_almadia ' + 'add-review-book btn-sm"' + 'data-slug ="' + row.slug + '"><i class="fa-regular fa-newspaper"></i></button> ' +
                    button_reading_guide

            }
        }],
        language: {
            url: "https://cdn.datatables.net/plug-ins/2.0.3/i18n/es-ES.json"
        },
    })

    let list_book_table = $("#table-books").DataTable()

    $("#add-book").on('click', function (e) {
        e.preventDefault()
        $('#form-add-book').trigger("reset")
        clearInputs()
        $(".modal-title-books").text('Agregar libro')
        $(".avatarImg").attr("src", "../images/covers/book.png")
        $("#item-link_ebook").val('https://linktr.ee/editorial_almadia');
        $("#modal-book").modal('show')
    })

    $("#table-books tbody").on('click', '.edit-admin-book', function (e) {
        e.preventDefault()
        $('#form-add-book').trigger("reset")
        rowData = list_book_table.row($(this).parents('tr')).data()
        $(".image").val('')
        $.each(rowData, function (index, value) {
            console.log(index, value)

            $(".item-" + index).val(value)
            if (index === "novedad") $('#novedad').prop('checked', value === "Y");
            if (index === "image") validaAvatar(value)
            if (index === "collection_id") addOptionToSelectChoise('select-collection_id-books', value)
            if (index === "authors") addOptionToSelectChoise('select-authors-books', value)
            if (index === "country_id") {
                $('.select-countrys_id-books').val(value.id).trigger("chosen:updated")
            }

            $("#modal-book").modal('show')
        })
    })

    $("#add-author-books").on('click', function (e) {
        e.preventDefault()
        $('#form-author-book').trigger("reset")
        clearFormAuthors()
        $("#modal-author-book").modal('show')
        $("#modal-book").modal('hide')
    })

    $("#table-books tbody").on('click', '.change-book-status', function (e) {
        e.preventDefault()
        let data = new FormData()
        data.append('id', $(this).data('book_id'))
        $(".loader_").addClass("loading")
        sendDataBooks(data, '/admin/change-book-status', 'example')
    })

    $("#table-books tbody").on('click', '.add-reading-guide', function (e) {
        e.preventDefault()
        let guide = $(this).data('reading-guide')
        let filePath = `/documents/reading-guide/${guide}`;

        if (guide === null) {
            $(".link-download-guide").hide()
        }else{
            $(".link-download-guide").show()
        }

        document.getElementById('download-link').setAttribute('href', filePath);

        $("#item-book-slug").val($(this).data('slug'))
        $("#modal-reading-guide").modal('show')
    })


    $("#form-author-book").on('submit', function (e) {
        e.preventDefault()
        let data = new FormData(this)
        $("#modal-book").modal('show')
        sendData(data, '/admin/add-author', 'modal-author-book')
    })

    $("#form-add-book").on('submit', function (e) {
        e.preventDefault()
        let data = new FormData(this)
        sendDataBooks(data, "/admin/book/sendInfo", 'modal-book')
        clearSpan()
    })

    $("#form-reading-guide").on('submit', function (e) {
        e.preventDefault()
        let data = new FormData(this)
        sendDataBooks(data, "/admin/book/add-reading-guide", 'modal-reading-guide')
    })

    function sendDataBooks(data, route, modal) {
        $(".loader_").addClass("loading")
        $.ajax({
            url: route, type: "post", data: data, processData: false, contentType: false, headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }, success: function (data) {
                setTimeout(function () {
                    $(".loader_").removeClass("loading")
                    if (data.type === "success") {
                        $("#table-books").DataTable().ajax.reload();
                        alertSuccess(data.msg)
                        $("#" + modal).modal('hide')
                    } else {
                        alertError(data.msg)
                    }
                }, 1000)

            }, error: function (errors, xhr, status,) {
                $(".loader_").removeClass("loading")
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $(".item-" + index).addClass('is-invalid')
                    $(".item-error-" + index).text(value);
                });
            }
        })
    }

    $(document).on('submit', '#form-details-book', function (e) {
        e.preventDefault()
        let data = new FormData(this)
        sendDataDetailBoosk(data)
    })

    $(document).on('click', '.delete_item', function (e) {
        e.preventDefault()
        let data = new FormData()
        let slug = $(this).data('slug');
        let id = $(this).data('id');
        let row = $(this).data('row');

        $(".loader_").addClass("loading")
        data.append('id', id)
        data.append('slug', slug)
        $.ajax({
            url: '/delete-detail-publication-book',
            type: "post",
            data: data,
            processData: false, contentType: false, headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }, success: function (data) {
                setTimeout(function () {
                    $(".loader_").removeClass("loading")
                    if (data.type == "success") {
                        $('#row-' + row).remove()
                        $("#table-books").DataTable().ajax.reload()
                    } else {
                        alertError(data.msg)
                    }
                }, 1000)

            }, error: function (errors, xhr, status,) {
                $(".loader_").removeClass("loading")
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $(".item-" + index).addClass('is-invalid')
                    $(".item-error-" + index).text(value);
                });
            }
        })
    })

    function sendDataDetailBoosk(data) {
        $(".loader_").addClass("loading")
        $.ajax({
            url: '/save-details-book',
            type: "post",
            data: data,
            processData: false, contentType: false, headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }, success: function (data) {
                setTimeout(function () {
                    $(".loader_").removeClass("loading")
                    if (data.type == "success") {
                        alertSuccess(data.msg)
                        $("#modal-details-book").modal('hide')
                    } else {
                        alertError(data.msg)
                    }
                }, 1000)

            }, error: function (errors, xhr, status,) {
                $(".loader_").removeClass("loading")
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $(".item-" + index).addClass('is-invalid')
                    $(".item-error-" + index).text(value);
                });
            }
        })

    }

    function sendData(data, route, modal) {
        $.ajax({
            url: route, type: "post", data: data, processData: false, contentType: false, headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }, success: function (data) {
                addAuthorToSelect(data.author)
                $("#modal-author-book").modal('hide')
                $("#modal-book").modal('show')

                $('.scrollable').css('overflow-y', 'scroll');

                setTimeout(function () {
                    $(".loader_").removeClass("loading")
                    if (data.type == "success") {
                        alertSuccess(data.msg)
                    } else {
                        alertError(data.msg)
                    }
                }, 1000)

            }, error: function (errors, xhr, status,) {
                $(".loader_").removeClass("loading")
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $(".item-" + index).addClass('is-invalid')
                    $(".item-error-" + index).text(value);
                });
            }
        })
    }

    function addAuthorToSelect(author) {
        var select = $('.select-authors-books');
        var option = $('<option>')
            .val(author.id)
            .text(author.name);
        select.append(option);
        $('.select-authors-books').trigger("chosen:updated");
    }

    function addOptionSelectAuthor() {
        var newOption = document.createElement('option');
        newOption.value = option.value;
        newOption.text = option.text;
        select.add(newOption);
    }

    function addOptionToSelectChoise(classe, value) {
        $('.' + classe).val(JSON.parse("[" + value + "]"))
        $('.' + classe).trigger("chosen:updated")
    }

    function clearSpan() {
        $(".item-error-name").text('')
        $(".item-error-price").text('')
        $(".item-error-authors").text('')
        $(".item-error-isbn").text('')
        $(".item-error-ean").text('')
        $(".item-error-gender").text('')
        $(".item-error-language").text('')
        $(".item-error-type_edition").text('')
        $(".item-error-edition").text('')
        $(".item-error-link-video").text('')
        $(".item-error-book-info").text('')
        $(".item-error-image").text('')
        $(".item-error-synopsis").text('')
        $(".item-error-price").text('')
        $(".item-error-publication_date").text('')
    }

    function clearInputs() {
        $(".item-id").val('')
        $('.select-authors-books').trigger("chosen:updated")
        $('.select-countrys_id-books').val('')
        $('.select-countrys_id-books').trigger("chosen:updated")

        $('.select-collection_id-books').val('')
        $('.select-collection_id-books').trigger("chosen:updated")
    }

    function clearFormAuthors() {
        $('.item-country').val('')
        $('.item-country').trigger("chosen:updated")
        $('.item-avatar').attr('src', '')
    }

    function validaAvatar(img) {
        $(".avatarImg").attr("src", "../images/covers/" + img);
    }

    function getIconReadingGuide(row) {
        let icon = "";
        let guide = null;
        if (row.reading_guide === null) {
            icon = '<i class="fa-brands fa-glide"></i>';
        } else {
            icon = '<i class="fa-solid fa-file"></i>';
            guide = row.reading_guide
        }
        return '<button data-toggle="tooltip" data-placement="top" title="Agregar guia de lectura." ' +
        'class="btn button_almadia ' + 'add-reading-guide btn-sm"' +
        'data-reading-guide ="' + guide + '"' +
        'data-slug ="' + row.slug + '"' +
        '>'+ icon +'</button> '
    }


})
